/**
 * Archived Message Card
 * Mirrors DeletedChildCard — red/pink theme, Re-establish + permanent delete buttons.
 */
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { RefreshCw, Trash2, MessageSquare } from "lucide-react";

export const ArchivedMessageCard = ({ msg, onRestore, onDelete }) => {
  const date = (() => {
    const dt = new Date(msg.archivedAt || msg.createdAt);
    return isNaN(dt.getTime()) ? "" : dt.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  })();

  return (
    <Card className="bg-red-50/80 backdrop-blur-sm border-2 border-red-200" data-testid={`archived-message-card-${msg.id}`}>
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 min-w-0">
            <p className="text-base font-semibold text-red-900">{msg.parentName}</p>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <Badge variant="outline" className="border-red-300 text-red-700 text-xs">Archived</Badge>
              {msg.childNames?.length > 0 && (
                <span className="text-xs text-red-600">re: {msg.childNames.join(", ")}</span>
              )}
              {date && <span className="text-xs text-red-500">{date}</span>}
            </div>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button
              onClick={() => onRestore(msg)}
              variant="outline"
              size="sm"
              className="border-green-300 text-green-700 hover:bg-green-50"
              title="Re-establish — move back to inbox"
              data-testid={`reestablish-message-${msg.id}`}
            >
              <RefreshCw className="w-4 h-4 mr-1" />
              <span className="hidden sm:inline">Re-establish</span>
            </Button>
            <Button
              onClick={() => onDelete(msg)}
              variant="outline"
              size="sm"
              className="border-red-500 text-red-700 hover:bg-red-100"
              title="Permanently delete"
              data-testid={`permanent-delete-message-${msg.id}`}
            >
              <Trash2 className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="rounded-lg bg-red-100/60 px-3 py-2">
          <p className="text-sm text-red-800">{msg.message}</p>
        </div>
        {msg.replies?.length > 0 && (
          <p className="text-xs text-red-500 mt-2 flex items-center gap-1">
            <MessageSquare className="w-3 h-3" />
            {msg.replies.length} {msg.replies.length === 1 ? "reply" : "replies"}
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default ArchivedMessageCard;
